import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";

/** code generate by generateapi don't edit */
import { getClient } from './internal'; // @cat:
// @name:
// @desc: 待废弃
// @error:
// ErrConfigMiss 配置缺失
// ErrUploadFail

/** @type {(r: storage.UploadReq, b: any) => Promise<storage.UploadRes>} TypeScript syntax */

export function Upload(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/Upload",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 待废弃
// @error:
// ErrConfigMiss 配置缺失
// ErrAppIdNotFound

/** @type {(r: storage.PreUploadReq, b: any) => Promise<storage.PreUploadRes>} TypeScript syntax */

export function PreUpload(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/PreUpload",
    "auth": "1"
  }), o));
}
; // @error:
// ErrTimeout

/** @type {(r: storage.GetQiniuAvinfoReq, b: any) => Promise<storage.GetQiniuAvinfoRes>} TypeScript syntax */

export function GetQiniuAvinfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetQiniuAvinfo",
    "auth": "1"
  }), o));
}
; // @error:
// ErrQiniuNoSuchFileOrDirectory

/** @type {(r: storage.QiniuPfopReq, b: any) => Promise<storage.QiniuPfopRes>} TypeScript syntax */

export function QiniuPfop(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/QiniuPfop",
    "auth": "1"
  }), o));
}
; // @error:
// ErrConfigMiss 配置缺失
// ErrQiniuNoSuchFileOrDirectory

/** @type {(r: storage.QiniuPfopV1Req, b: any) => Promise<storage.QiniuPfopV1Rsp>} TypeScript syntax */

export function QiniuPfopV1(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/QiniuPfopV1",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 查询文件状态, 后台服务调用
// @error:
// ErrResourceNotFound
// @gen: t=get_model_db_proxy;m=ModelResource

/** @type {(r: storage.GetResourceReq, b: any) => Promise<storage.GetResourceRsp>} TypeScript syntax */

export function GetResource(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetResource",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 待废弃，改用 GetDownloadUrl
// @error:
// ErrStorageTypeOnlySupportedQiniu

/** @type {(r: storage.GetPrivateUrlReq, b: any) => Promise<storage.GetPrivateUrlRsp>} TypeScript syntax */

export function GetPrivateUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetPrivateUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc: 批量获取URL
// @error:
// ErrConfigMiss 配置缺失

/** @type {(r: storage.BatchGetUrlReq, b: any) => Promise<storage.BatchGetUrlRsp>} TypeScript syntax */

export function BatchGetUrl(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/BatchGetUrl",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrConfigMiss 配置缺失
// ErrTimeout
// ErrInvalidTask 非法任务
// ErrTaskNotFound 任务不存在
// ErrInvalidConfig 非法任务
// @gen_to: qiniu
// svr options: (ext.UserType) = c

/** @type {(r: storage.QiniuCallbackReq, b: any) => Promise<storage.QiniuCallbackRsp>} TypeScript syntax */

export function QiniuCallback(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/QiniuCallback",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// @gen: t=get_model_list_db_proxy
// svr options: (ext.UserType) = staff

/** @type {(r: storage.GetResourceListReq, b: any) => Promise<storage.GetResourceListRsp>} TypeScript syntax */

export function GetResourceList(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetResourceList",
    "auth": "1"
  }), o));
}
; // @error:
// ErrConfigMiss 配置缺失
// ErrConfigNotFound 配置不存在
// svr options: (ext.UserType) = pub
// svr options: (ext.Url) = /storage/aliyun/callback/notifications

/** @type {(r: storage.AliyunNotificationsReq, b: any) => Promise<storage.AliyunNotificationsRsp>} TypeScript syntax */

export function AliyunNotifications(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/AliyunNotifications",
    "auth": "0"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrStorageTypeNotSupport
// ErrConfigMiss 配置缺失
// ErrConfigNotFound 配置不存在

/** @type {(r: storage.UpdateResourceInfoReq, b: any) => Promise<storage.UpdateResourceInfoRsp>} TypeScript syntax */

export function UpdateResourceInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/UpdateResourceInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrConfigMiss 配置缺失
// @gen_to: web

/** @type {(r: storage.UploadResourceReq, b: any) => Promise<storage.UploadResourceRsp>} TypeScript syntax */

export function UploadResource(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/UploadResource",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrConfigMiss 配置缺失
// ErrInvalidResourceState
// @gen_to: web

/** @type {(r: storage.UploadResourceCallBackReq, b: any) => Promise<storage.UploadResourceCallBackRsp>} TypeScript syntax */

export function UploadResourceCallBack(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/UploadResourceCallBack",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrTcRequestErr
// ErrInvalidConfig 非法任务

/** @type {(r: storage.GetMediaMetaInfoReq, b: any) => Promise<storage.GetMediaMetaInfoRsp>} TypeScript syntax */

export function GetMediaMetaInfo(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetMediaMetaInfo",
    "auth": "1"
  }), o));
}
; // @cat:
// @name:
// @desc:
// @error:
// ErrTcRequestErr
// ErrInvalidConfig 非法任务

/** @type {(r: storage.GetMediaSnapshotReq, b: any) => Promise<storage.GetMediaSnapshotRsp>} TypeScript syntax */

export function GetMediaSnapshot(r, o) {
  return getClient.call(null, r, _objectSpread(_objectSpread({}, {
    "url": "/storage/GetMediaSnapshot",
    "auth": "1"
  }), o));
}
;
var StorageServices = {
  Upload: Upload,
  PreUpload: PreUpload,
  GetQiniuAvinfo: GetQiniuAvinfo,
  QiniuPfop: QiniuPfop,
  QiniuPfopV1: QiniuPfopV1,
  GetResource: GetResource,
  GetPrivateUrl: GetPrivateUrl,
  BatchGetUrl: BatchGetUrl,
  QiniuCallback: QiniuCallback,
  GetResourceList: GetResourceList,
  AliyunNotifications: AliyunNotifications,
  UpdateResourceInfo: UpdateResourceInfo,
  UploadResource: UploadResource,
  UploadResourceCallBack: UploadResourceCallBack,
  GetMediaMetaInfo: GetMediaMetaInfo,
  GetMediaSnapshot: GetMediaSnapshot
};
export default StorageServices;